export const POST_NEWSLETTER_ACTION = "POST_NEWSLETTER_ACTION";
export const POST_NEWSLETTER_ACTION_SUCCESS = "POST_NEWSLETTER_ACTION_SUCCESS";
export const POST_NEWSLETTER_ACTION_FAILURE = "POST_NEWSLETTER_ACTION_FAILURE";

export const POST_NEWSLETTER_ACTION_LOADING = "POST_NEWSLETTER_ACTION_LOADING";

export const RESET_NEWSLETTER_STATE = "RESET_NEWSLETTER_STATE";
export const RESET_NEWSLETTER_STATE_SUCCESS = "RESET_NEWSLETTER_STATE_SUCCESS";